<template> 
    <div>
        <section class="hero is-info">
            <div class="hero-body">
                <div class="container">
                    <div class="columns">
                        <div class="column is-three-fifths is-offset-one-fifth">
                            <h1 class="title">Hi {{ LoggedInProfile.firstName }},</h1>
                            <h2 class="subtitle">welcome to your basic profile information page.</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-three-fifths is-offset-one-fifth">
                        <b-message type="is-info" has-icon>Please keep the information updated and contact us if anything changes during use. Also read our <a href="#">Privacy Policy</a> on how we deal with your personal data.</b-message>
                        <div class="box">
                            <div class="columns is-centered">
                                <div class="column is-three-quarters">
                                   <b-field>
                                        <b-button @click="toggleEditingMode" :label="editButton" icon-pack="fas"  icon-left="cog" class="button is-warning top-bottom-margin-customized"/>
                                        <b-button @click="saveProfile" label="Save changes" :loading="isLoading" :disabled="editingBlocked" class="button is-info top-bottom-margin-customized left-right-margin-customized"/>
                                    </b-field>
                                    <router-view :profile="LoggedInProfile" :editingBlocked="editingBlocked"></router-view>
                                    <p class="top-bottom-margin-customized"><b>Note:</b> Password cannot be changed as of Alpha version.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style scoped>
    .top-bottom-margin-customized {
        margin-bottom: 1.5rem;
        margin-top: 1.5rem;
    }

    .left-right-margin-customized {
        margin-left: 1.5rem;
        margin-right: 1.5rem;
    }
</style>

<script>

// Saving happens through the Vuex store but is triggered from this component. 
// Implement load state while the async request is performed for improved UX. 
// Implement correct error/success indicators. 
export default {
    computed: {
        LoggedInProfile() {
            return this.$store.state.userProfile;
        },
        isLoading() {
            return this.$store.state.loading;
        }
    },
    data: function() {
        return {
          editingBlocked: true,
          editButton: "Edit"
        }
    },
    methods: {
        toggleEditingMode: function() {
            this.editingBlocked = !this.editingBlocked;
            if (this.editButton == "Edit") {
                this.editButton = "Cancel";
                 this.$buefy.snackbar.open({type: "is-info", message: "Editing"});
            } else {
                this.editButton = "Edit";
                window.location.reload();
            }
        },
        saveProfile: function() {
            this.$store.dispatch("updateProfileInformation", this.LoggedInProfile);
            this.editButton = "Edit";
            this.editingBlocked = true;
        }
    }
}
</script>